import { Flex } from '../../../layout/Flex';
import { Typography } from '../../../typography/Typography';
import { PropertyProps } from '../types';

export const Property = (props: PropertyProps) => (
    <Flex
        direction={{ xs: 'row', sm: 'column' }}
        alignItems={{ sm: 'flex-end' }}
        spacing={{ xs: 0.5, sm: 0 }}
    >
        <Typography weight="medium">{props.value}</Typography>
        <Typography weight="regular" color="secondary">
            {props.displayName}
        </Typography>
    </Flex>
);
